import { render, staticRenderFns } from "./ElectricalActivities.vue?vue&type=template&id=077e4db1&scoped=true"
import script from "./ElectricalActivities.vue?vue&type=script&lang=js"
export * from "./ElectricalActivities.vue?vue&type=script&lang=js"
import style0 from "./ElectricalActivities.vue?vue&type=style&index=0&id=077e4db1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077e4db1",
  null
  
)

export default component.exports